import { logEvent } from "firebase/analytics";
import { getAnalyticsInstance } from "./analyticsLoader";

export const trackEvent = (
  eventName: string,
  params?: Record<string, any>
) => {
  const analytics = getAnalyticsInstance();
  if (!analytics) return;

  logEvent(analytics, eventName, params);
};
